export default __webpack_public_path__ + "static/media/phase2.2888120d.png";